import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    computed: {
        hasHubSpotIntegration() {
            return this.hasIntegrationUser('hubspot');
        },

        hasPipedriveIntegration() {
            return this.hasIntegrationUser('pipedrive');
        },

        hasAircallIntegration() {
            return this.hasIntegrationUser('aircall');
        },

        hasInfusionsoftIntegration() {
            return this.hasIntegrationUser('infusionsoft');
        },

        hasActivecampaignIntegration() {
            return this.hasIntegrationUser('activecampaign');
        },

        hasSlackIntegration() {
            return this.hasIntegrationUser('slack');
        },

        hasIntegrations() {
            if (!Array.isArray(this.integrations)) return false;

            return Boolean(this.integrations.length);
        },

        hasUserIntegrations() {
            if (!Array.isArray(this.userIntegrations)) return false;

            return Boolean(this.userIntegrations.length);
        },

        hasUserIntegrationsTeams() {
            if (!this.hasUserIntegrations) return false;
            if (!Array.isArray(this.userIntegrationsTeams)) return false;

            return Boolean(this.userIntegrationsTeams.length);
        },

        getErrorIntegrations() {
            if (!this.hasIntegrations) return '';

            return this.userIntegrations
                .filter((item) => item.connection_error === 1)
                .map((item) => item.integration.name)
                .join(', ');
        },

        getIntegrationskeys() {
            if (!this.hasIntegrations) return '';

            return this.userIntegrations?.map((item) => item.integration.key).join(' ,') || '';
        },

        connectedIntegrations() {
            return this.userIntegrations?.map((item) => item.integration.key) || [];
        },

        ...mapState(stores.Integrations, [
            'integrations',
            'userIntegrations',
            'userIntegrationsTeams',
            'integrationFields',
            'integrationsSettingsPermit',
            'integrationsLoading',
            'hubSpotContactLists',
            'loadedHubSpotContactLists',
        ]),
    },

    methods: {
        existIntegration(value) {
            return this.integrations.find((item) => item.id === value || item.key === value);
        },

        // userIntegrations
        hasIntegrationUser(value) {
            return Boolean(this.getIntegrationUser(value));
        },

        getIntegrationUser(value, { checkError = true } = {}) {
            if (!this.hasIntegrations) return null;

            return this.userIntegrations
                .filter((item) => (checkError ? !item.connection_error : true))
                .find((o) => o.integration.key === value || o.integration.id === value);
        },

        getIntegrationUserPropsId(value) {
            if (!this.hasIntegrations) return null;

            return this.getIntegrationUser(value)?.integration_id || '';
        },

        getIntegrationUserPropsIntegration(value) {
            if (!this.hasIntegrations) return null;

            return this.getIntegrationUser(value)?.integration || '';
        },

        // integrations
        getIntegrationList(value) {
            if (!this.hasIntegrations) return null;

            return this.integrations.find((o) => o.key === value || o.id === value);
        },

        getIntegrationListPropsId(value) {
            if (!this.hasIntegrations) return null;

            return this.getIntegrationList(value)?.id || '';
        },

        // other methods
        excludeIntegrationsList(array = [], check = true) {
            if (!this.hasIntegrations) return [];

            return this.integrations.filter((integration) => {
                if (array.includes(integration.key)) return false;

                if (!check) return integration;

                return (
                    this.userIntegrations.findIndex((i) => i.integration_id === integration.id) !==
                    -1
                );
            });
        },

        excludeIntegrationsUser(array = []) {
            if (!this.hasIntegrations) return [];

            return this.userIntegrations.filter((item) => !array.includes(item.integration.key));
        },

        allowIntegrationsList(array = [], check = true) {
            if (!this.hasIntegrations) return [];

            return this.integrations.filter((integration) => {
                return array.includes(integration.key);
            });
        },

        allowIntegrationsUser(array = []) {
            if (!this.hasIntegrations) return [];

            return this.userIntegrations.filter((item) => array.includes(item.integration.key));
        },

        connectedIntegration(key) {
            return this.connectedIntegrations.includes(key);
        },
    },
};
